<template>
	<div
		class="arrow_wrap"
		@click="onClicked"
	>
		<span></span>
		<span></span>
	</div>
</template>
<script>
export default {
	methods: {
		onClicked() {
			this.$emit("click");
		},
	},
};
</script>
<style scoped lang="less">
.arrow_wrap {
	position: relative;
	z-index: 10;
	width: 0.8rem;
	white-space: nowrap;
	span {
		display: inline-block;
		width: 0.48rem;
		height: 0.56rem;
		background: url("../assets/arrow.png") no-repeat center/contain;
		margin-left: -0.2rem;
		animation: arrowMove 1s ease-in-out 0.1s infinite normal both;
	}
	span:nth-child(1) {
		animation-delay: 0.2s;
	}
	span:nth-child(2) {
		animation-delay: 0;
	}
}
@keyframes arrowMove {
	0% {
		transform: translate(0, 0);
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
	100% {
		transform: translate(100%, 0);
		opacity: 0;
	}
}
</style>